<div class="closeButton" >
    <button mat-icon-button [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
    </button>
</div>
<form [formGroup]="contactFormGroup"  align="center" >
    <div id="loginCard">
        <mat-card class="loginMatCard">
            <h1 mat-dialog-title>{{'keyword_$282' | translate}} {{user_name}}</h1>
        <div mat-dialog-content>
          <p>{{'keyword_$283' | translate}}</p>
        </div>
        <div mat-dialog-actions align="center">
          <button class="requestButtonClose" mat-button (click)="onNoClick()">{{'keyword_$228' | translate}}</button>
          <button class="requestButton" mat-button cdkFocusInitial (click)="submit()" >{{'keyword_$284' | translate}}</button>
        </div>
        </mat-card>
    </div>
</form>
